/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：将字典数据的id value 值转换成中文Name
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { SwJwtService } from '../../serves/sw-jwt.service';


/**
 * 将字典值转换成中文 第一种可以传入转换的值
 * @example  <span> {{ 'CKF010102' | Dictionary:'dictionaryValue' }}</span>
 * @example <span> {{ 'CKF010102' | Dictionary }}</span>
 */
@Pipe({
  name: 'dictionary',
  // 字典由异步接口写入缓存，加载完成后需要重新转换未变化的字典值。
  pure: false
})
export class DictionaryPipe implements PipeTransform {

  constructor(private jwt :SwJwtService){}

  /** 缓存原文未变化时复用解析结果，避免每次变更检测重复解析字典。 */
  private dictionaryCache: string;
  private dictionaryData: any[] = [];


  /**
   * 将字典值转换为当前语言的名称，缓存缺失或异常时返回空字符串。
   * @param value 传递的值 
   * @param dictionaryId 匹配字段，默认使用 dictionaryValue
   * @returns 匹配的字典名称，未匹配时返回空字符串
   */
  transform(value: any,dictionaryId?:any): any {
    if(value){
      let dictionaryCache = this.jwt.getToken("dictionary");
      if(dictionaryCache !== this.dictionaryCache){
        this.dictionaryCache = dictionaryCache;
        try {
          let dictionary = JSON.parse(dictionaryCache);
          this.dictionaryData = Array.isArray(dictionary) ? dictionary : [];
        } catch (error) {
          this.dictionaryData = [];
        }
      }
      let dictionary = this.dictionaryData;
      if(dictionary.length === 0){
        return "";
      }
       //获取当前语言
      let currLanguage = this.jwt.getToken('language')
      if(dictionaryId){
         let dic = dictionary.filter(x=>x && x[dictionaryId] == value); 
         let text = ''
         if(dic.length>0){
          if(currLanguage == 'en-US' && dic[0]['dictionaryNameEn']){
            text = dic[0]['dictionaryNameEn']
           }else {
            text = dic[0]["dictionaryName"]
           }
         }
        return dic.length>0? text:"";
      }else{
          let dic = dictionary.filter(x=>x && x.dictionaryValue == value); 
          let text = ''
          if(dic.length > 0){
            if(currLanguage == 'en-US' && dic[0]['dictionaryNameEn']){
              text = dic[0]['dictionaryNameEn']
            }else {
              text = dic[0]["dictionaryName"]
            }
          }
          return dic.length>0? text:"";
      }
    }else{
      return "";
    }
  }
}

//前台写法
//<span> {{ 'CKF010102' | dictionary:'dictionaryValue' }}</span>
//<span> {{ 'CKF010102' | dictionary }}</span>